import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const DateTimeSelectorFavPro = ({
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
  selectedDateScroll,
  modalIsOpen2,
  handleMonthChange,
  handleDayChange,
  handleDayClick,
  handleHourClick,
  daysToShow,
  hours,
  totalPrice,
  scrollLeft,
  scrollRight,
  openModal,
  getMonthName,
  getDayName,
  unavailableDates,
  availableHours,
  buffertime,
  totalDuration,
  traveldistance, //travelDistance: xx hours xx mins or xx mins
}) => {
  const { t } = useTranslation('therapist');
  const formatHour = (hour) => String(hour).replace(/^0(?=\d:)/, '');
  const parseTravelDistance = (travelDistance) => {
    if (typeof travelDistance !== "string") {
      return 0; // Default to 0 if travelDistance is not a string
    }

    const hoursRegex = /(\d+)\s*hours?/;
    const minutesRegex = /(\d+)\s*mins?/;

    const hoursMatch = travelDistance.match(hoursRegex);
    const minutesMatch = travelDistance.match(minutesRegex);

    const hours = hoursMatch ? parseInt(hoursMatch[1], 10) * 100 : 0;
    const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;

    return hours + minutes;
  };
  const dayContainerRef = useRef(null);
  const hoursContainerRef = useRef(null);
  const daySwipeRef = useRef(null);
  const hourSwipeRef = useRef(null);
  const getInitialVisibleHour = () => {
    if (selectedTime) {
      return selectedTime;
    }

    if (availableHours && typeof availableHours === 'object') {
      const firstAvailableEntry = Object.entries(availableHours).find(([, available]) => available);
      return firstAvailableEntry ? firstAvailableEntry[0] : null;
    }

    return null;
  };

  useEffect(() => {
    const container = hoursContainerRef.current;
    if (!container) {
      return;
    }

    const visibleHour = getInitialVisibleHour();

    if (!visibleHour) {
      container.scrollLeft = 0;
      return;
    }

    const scrollToHour = () => {
      const hourElements = container.querySelectorAll('.btn-hour');
      let element = null;
      for (let i = 0; i < hourElements.length; i++) {
        const el = hourElements[i];
        if (!el) continue;
        const text = (el.textContent || el.innerText || '').trim();
        if (text.indexOf(formatHour(visibleHour)) === 0 || text.startsWith(formatHour(visibleHour))) {
          element = el;
          break;
        }
      }

      if (element) {
        try {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } catch (e) {
          const containerWidth = container.offsetWidth || 0;
          const elementLeft = element.offsetLeft || 0;
          const elementWidth = element.offsetWidth || 0;
          const desiredLeft = Math.max(0, elementLeft - Math.floor((containerWidth - elementWidth) / 2));
          container.scrollTo({ left: desiredLeft, behavior: 'smooth' });
        }
      }
    };

    const frame = window.requestAnimationFrame(scrollToHour);
    return () => window.cancelAnimationFrame(frame);
  }, [selectedTime, availableHours, selectedDate]);

  const handleSwipeStart = (swipeRef) => (event) => {
    const touch = event.touches?.[0];

    if (!touch) {
      return;
    }

    swipeRef.current = {
      startX: touch.clientX,
      startY: touch.clientY,
      startScrollLeft: event.currentTarget.scrollLeft || 0,
    };
  };

  const handleSwipeEnd = (swipeRef, onSwipeLeft, onSwipeRight) => (event) => {
    const touch = event.changedTouches?.[0];
    const swipeState = swipeRef.current;
    swipeRef.current = null;

    if (!touch || !swipeState) {
      return;
    }

    const deltaX = touch.clientX - swipeState.startX;
    const deltaY = touch.clientY - swipeState.startY;
    const nativeScrollDelta = Math.abs((event.currentTarget.scrollLeft || 0) - swipeState.startScrollLeft);

    if (Math.abs(deltaX) < 32 || Math.abs(deltaX) <= Math.abs(deltaY)) {
      return;
    }

    if (nativeScrollDelta > 8) {
      return;
    }

    if (deltaX < 0) {
      onSwipeLeft();
    } else {
      onSwipeRight();
    }
  };

  const isHourAvailable = (hour, index) => {
    const now = new Date();
    const isToday = selectedDate?.toDateString() === now.toDateString();

    const travelTime = parseTravelDistance(traveldistance);
    // console.log('travelTime',travelTime)
    return availableHours.some(({ start_time, end_time }) => {
      const [hourHours, hourMinutes] = hour.split(':').map(Number);
      const hourValue = hourHours * 100 + hourMinutes;

      const [startHours, startMinutes] = start_time.split(':').map(Number);
      // const startValue = startHours * 100 + startMinutes + Number(buffertime.bufferBefore);
      // const startValue = startHours * 100 + startMinutes + Number(buffertime.bufferBefore) + travelTime;
      // console.log('startValue',startValue)
      let startValue = startHours * 100 + startMinutes + Number(buffertime.bufferBefore) + travelTime;

      if (index == 0) {
        if (isToday && hour !== start_time) {

          const requiredBufferStart = hourValue + Number(buffertime.bufferBefore) + travelTime;
          if (hourValue < requiredBufferStart) {
            return false;
          }
        }
      }

      const [endHours, endMinutes] = end_time.split(':').map(Number);
      const endValue = endHours * 100 + endMinutes - Number(buffertime.bufferAfter) - 40 - totalDuration - 40;
      return hourValue >= startValue && hourValue <= endValue;
    });
  };
  const safeSelectedDate = (selectedDate && !isNaN(selectedDate.getTime())) ? selectedDate : selectedDateScroll;
  
  return (
    <div>
      <div className={`form-group group-mois ${modalIsOpen2 && "group-mois-padding"}`}>
        {/* {!modalIsOpen2 &&
          <label>Mois</label>
        } */}
        <div className="btn-group" role="group">
          <button type="button" className="btn-slide btn-prev" onClick={() => handleMonthChange(-1)}>
            &lt;
          </button>
          <span className="text-month"> {getMonthName(safeSelectedDate)}</span>
          <button type="button" className="btn-slide btn-next btn-month" onClick={() => handleMonthChange(1)}>
            &gt;
          </button>
        </div>
      </div>
      <div className="form-group group-jour modal-therapist">
        {/* {!modalIsOpen2 &&
          <label>Jour</label>} */}
        <div className="btn-group" role="group">
          <button type="button" className="btn-slide btn-prev" onClick={() => handleDayChange(-1)}>
            &lt;
          </button>
          <div
            className="row-date"
            ref={dayContainerRef}
            onTouchStart={handleSwipeStart(daySwipeRef)}
            onTouchEnd={handleSwipeEnd(daySwipeRef, () => handleDayChange(1), () => handleDayChange(-1))}
          >
            {daysToShow.map((date) => {
              if (!date || isNaN(date.getTime())) {
                return null;
              }
              const isUnavailable = unavailableDates.includes(date.toDateString());
              return (
                <button
                  key={date.getTime()}
                  type="button"
                  className={`btn-day ${!isUnavailable ? 'disabled' : ''} ${date?.toDateString() === selectedDate?.toDateString() ? 'selected' : ''
                    }`}
                  onClick={() => isUnavailable && handleDayClick(date)}
                  disabled={!isUnavailable}
                >
                  {`${getDayName(date)}`} <br /> <span>{`${date.getDate()}`}</span>
                  <br /> {`${!isUnavailable ? t('epuise') : ''}`}
                </button>
              );
            })}
          </div>
          <button type="button" className="btn-slide btn-next btn-month" onClick={() => handleDayChange(1)}>
            &gt;
          </button>
        </div>
      </div>
      <div className="form-group group-heure modal-therapist">
        {/* <label>{!modalIsOpen2 ? 'Heure' : 'Durée'}</label> */}
        {selectedDate && selectedDate.getDay() !== 0 ? (
        <div className="btn-group" role="group">
          <button type="button" className="btn-slide btn-prev" onClick={scrollLeft}>
            &lt;
          </button>
          <div
            className="row-day"
            ref={hoursContainerRef}
            onTouchStart={handleSwipeStart(hourSwipeRef)}
            onTouchEnd={handleSwipeEnd(hourSwipeRef, scrollRight, scrollLeft)}
          >
            {Object.entries(availableHours).every(([_, available]) => !available) ? (
              <div className="fully-booked-message">
                {t('fully_booked_message_single')}
              </div>
            ) : (
              Object.entries(availableHours).map(([hour, available]) => {
                const isSunday = safeSelectedDate && safeSelectedDate.getDay && !isNaN(safeSelectedDate.getTime()) && safeSelectedDate.getDay() === 0;
                return (
                  <button
                    type="button"
                    key={hour}
                    className={`btn-hour ${!available || isSunday ? 'disabled' : ''} ${selectedTime === hour || isSunday ? 'selected' : 'btn-outline-primary'
                      }`}
                    onClick={() => available && handleHourClick(hour)}
                    disabled={!available}
                  >
                    {formatHour(hour)} <br />
                    <span>{totalPrice}&nbsp;CHF</span>
                    <br /> {`${!available && !isSunday ? t('epuise') : isSunday ? 'Hotel' : ' '}`}
                  </button>
                );
              })
            )}
          </div>
          <button type="button" className="btn-slide btn-next btn-month" onClick={scrollRight}>
            &gt;
          </button>
        </div>
                ) : (
                  ''
                  )}
        {!modalIsOpen2 && window.location.pathname !== "/flypro-booking" &&
          <>
            <a href="#0" className="filter-user" onClick={openModal}>
              Filtrer vos préférences
            </a>
            <p>Veuillez sélectionnez le flypro ou cliquez sur le bouton aucune préférence</p>
          </>
        }
      </div>
    </div>
  );
};

export default DateTimeSelectorFavPro;
